import React, {Component} from "react";
import {Field, reduxForm} from "redux-form";
import moment from "moment";
import {TextField} from "redux-form-material-ui";

const renderField = (props) => (
  <input  {...props} />
);
const Comments = (() => {
  return (
    <TextField
      hintText="Enter comments if any"
      multiLine={true}
      rows={2}
      rowsMax={4}/>
  );
});
const validate = values => {
  const errors = {};
  if (values.contactNo.length != 10)
    errors.contactNo = "Invalid Mobile No"
  if (values.emailId && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.emailId)) {
    errors.emailId = 'Invalid email address'
  }
  return errors
}

class Form extends Component {
  constructor() {
    super();
    this.state = {startDate: moment()}
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(date) {
    this.setState({
      startDate: date
    });
  }

  componentDidMount() {
    // on TextField
  }

  render() {
    const style = {
      "fontSize": "20px"
    };
    const stylePaper = {
      height: "75%",
      width: "75%",
      margin: 20,
      textAlign: 'left',
      display: 'inline-block',
    };


    const {handleSubmit, pristine, reset, submitting} = this.props;
    console.log("here are my props");
    console.log(this.props);
    return (

      <form onSubmit={handleSubmit(data => {
        console.log(data);
      })}>
        <div className="col-xs-12">
          <div className="col-xs-6">
            <Field name="emailId" component={TextField} hintText="Personal Email Id"
                   floatingLabelText="Personal Email Id"
                   ref="emailId" withRef/>
            <button className="btn btn-default btn-block" type="submit" disabled={pristine || submitting}>Save</button>

          </div>
          <div className="col-xs-6">
            <Field name="contactNo" component={TextField} hintText="Contact No" floatingLabelText="Contact No"/>

          </div>


        </div>
      </form>

    )
  }
}

export default reduxForm({
  form: 'personalForm',
  validate
})(Form)



/** WEBPACK FOOTER **
 ** ./src/components/common/forms/PersonalForm.js
 **/